import React, { useContext } from "react";
import ReactModal from "react-modal";
import SidebarContext from "../sidebar-context";
import { IProps } from "./sidebar.types";
import { PARENT_SELECTOR, ROOT_ID, STACKING_LAYERS_ID } from "@edgetier/modal";
import "./sidebar.scss";

/**
 * A sidebar that will appear on the left-hand side of the screen.
 * @param props.children The contents of the sidebar.
 */
const Sidebar = ({ children, className }: IProps) => {
    const { isOpen, hideSidebar } = useContext(SidebarContext);

    if (isOpen) {
        return (
            <ReactModal
                ariaHideApp={false}
                className="sidebar__outer"
                isOpen={isOpen}
                onRequestClose={hideSidebar}
                overlayClassName="sidebar__overlay"
                parentSelector={() =>
                    document.querySelector(STACKING_LAYERS_ID) ??
                    document.querySelector(PARENT_SELECTOR) ??
                    document.querySelector(ROOT_ID) ??
                    document.body
                }
                shouldCloseOnEsc={true}
                shouldCloseOnOverlayClick={true}
            >
                <div className={`sidebar ${className ?? ""}`}>{children}</div>
            </ReactModal>
        );
    } else {
        return null;
    }
};

export default Sidebar;
